import { moments } from "@/mocks/home";

const filters = ["全部", "直播", "舞台", "街头", "首发"];

export default function MomentGallery() {
  return (
    <section id="moments" className="bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold tracking-[0.22em] text-primary-600">
              <span className="h-px w-6 bg-primary-400" />
              MOMENTS · 每期一帧
            </p>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black tracking-tight text-foreground-950">
              名场面大赏
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              把掌声骤停、镜头前的长叹与被反复回放的那一秒，做成一张张封面。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {filters.map((f, idx) => (
              <button
                key={f}
                type="button"
                className={`rounded-full px-3 py-1.5 text-xs font-medium whitespace-nowrap cursor-pointer ${
                  idx === 0
                    ? "bg-foreground-950 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {moments.map((m, idx) => (
            <a
              href="#archive"
              key={m.title}
              className="group relative aspect-[3/4] overflow-hidden rounded-xl bg-background-100"
            >
              <img
                src={m.cover}
                alt={`${m.title}，51大雷翻车名场面`}
                className="group-img h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/10 to-transparent" />
              <span className="absolute left-3 top-3 rounded-md bg-accent-500 text-foreground-950 px-2 py-1 text-[11px] font-bold whitespace-nowrap">
                {m.label}
              </span>
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <span className="text-[11px] font-semibold text-accent-300 whitespace-nowrap">
                  {idx % 2 === 0 ? "掌声组 · 实时回放" : "沉默组 · 逐帧品鉴"}
                </span>
                <h3 className="mt-1 font-heading text-base md:text-xl font-bold leading-snug text-background-50">
                  {m.title}
                </h3>
                <p className="mt-1 text-xs text-background-50/75">{m.caption}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}